<mat-dialog-content style="height: 53vh;">
    <div layout="row" layout-align="center center">
        <div style="margin-bottom: 2%;">
            <strong >{{titulo}}</strong>
        </div>
        <div class="mod-container" style="margin-top: 20px;">
            <mat-form-field style="margin-bottom: 20px; width: 90%; margin-left: 5%;">
                <input matInput placeholder="Casilla de mail" 
                    [(ngModel)]=mail>
            </mat-form-field>
        </div>
        <div class="mod-container">
            <table style="width: 90%; margin-left:5%;">
                <tr>
                    <td style="width: 50%;">
                        <mat-form-field style="width: 95%;">
                            <input matInput placeholder="Contraseña" 
                                [(ngModel)]=pass>
                        </mat-form-field>
                    </td>
                    <td style="width: 25%;">
                        <mat-form-field style="width: 95%;">
                            <input matInput placeholder="SMTP" 
                                [(ngModel)]=smtp>
                        </mat-form-field>
                    </td>
                    <td style="width: 25%;">
                        <mat-form-field style="width: 95%;">
                            <input matInput placeholder="Puerto SMTP" 
                                [(ngModel)]=puertoSmtp>
                        </mat-form-field>
                    </td>
                </tr>
            </table>
        </div>
        <div>
            <table style="width: 90%; margin-left: 5%;">
                <tr>
                    <td style="width: 50%;">
                        <mat-form-field style="width: 95%;">
                            <input matInput placeholder="Con copia" 
                                [(ngModel)]=conCopia>
                        </mat-form-field>
                    </td>
                    <td style="width: 25%;">
                        <mat-checkbox style="width: 95%;" color="primary"
                            [(ngModel)]=ssl>SSL
                        </mat-checkbox>
                    </td>
                    <td style="width: 25%;">
                        <mat-checkbox style="width: 95%;" color="primary"
                            [(ngModel)]=habilitada>Habilitada
                        </mat-checkbox>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</mat-dialog-content>
<div style="text-align: center;">
    <table style="width: 100%; text-align: center;">
        <tr>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="cerrar('cancela')">
                    <i class="fas fa-arrow-circle-left fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Cancelar
                </button>
            </td>
            <td style="width: 20%;"></td>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="almacenar()" style="margin-left: 30px;">
                    <i class="fas fa-save fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Almacenar
                </button>
            </td>
        </tr>
    </table>
</div>
